module.exports = require('./helpers/bundle-url').getBundleURL('kBF18') + "logo.c51670a8.svg";